class VimeoEmbeddedContainer extends HTMLElement {
  connectedCallback() {
    this.videos = this.querySelectorAll('vimeo-embedded-modal');
    this.slider = this.querySelector('slider-component');
    this.totalVideos = this.videos?.length || 0;
    this.errors = 0;
    this.success = 0;
    this.ignoreThumbs = 0;
    this.ratios = [];
    this.modalId = this.getAttribute('data-modal-id');
    this.modal = null;
    this.modalContent = null;

    document.body.addEventListener('modalClosed', () => {
      if (this.modalContent) {
        this.modalContent.innerHTML = '';
      }
    });
  }
  addRatio(height, width) {
    const h = Number(height);
    const w = Number(width);

    if (!Number.isFinite(h) || !Number.isFinite(w) || w <= 0 || h <= 0) {
      this.incrementIgnoreThumb();
      return;
    }

    const ratio = h / w;

    if (!Number.isFinite(ratio) || ratio <= 0) {
      this.incrementIgnoreThumb();
      return;
    }

    this.ratios.push(ratio);
    this.checkIfAllThumbsProcessed();
  }
  incrementErrors(){
    this.errors++;
    this.checkIfAllThumbsProcessed();
    if (this.success + this.errors === this.totalVideos) {
      this.setSectionReadyToRender();
    }
  }
  incrementIgnoreThumb(){
    this.ignoreThumbs++;
    this.checkIfAllThumbsProcessed()
  }
  incrementSuccess(){
    this.success++;
    if (this.success + this.errors === this.totalVideos) {
      this.setSectionReadyToRender();
    }
  }
  checkIfAllThumbsProcessed() {
    if (this.ratios.length + this.ignoreThumbs + this.errors === this.totalVideos) {
      this.setHighestRatio();
    }
  }
  setHighestRatio(){
    if (!this.ratios.length) return;

    const highestRatio = Math.max(...this.ratios);

    this.style.setProperty(
      '--vimeo-thumb-padding',
      `${highestRatio * 100}%`
    );

    // this.classList.remove('hidden');
  }
  setSectionReadyToRender(){
    if (this.success > 0)
      this.classList.remove('hidden');
    else this.remove();
  }
  openModal(embedHtml) {
    if (!this.modal) {
      this.modal = window.document.getElementById(this.modalId);
    }
    if (!this.modalContent) {
      this.modalContent = this.modal.querySelector(".js_vimeo-modal-content");
    }
    if (!this.modal || !this.modalContent || !embedHtml) return;

    this.modalContent.innerHTML = '';
    this.modalContent.appendChild(this.parseIframe(embedHtml));

    this.modal.show(this);
  }
  parseIframe(html) {
    const template = document.createElement('template');
    template.innerHTML = html.trim();

    const iframe = template.content.querySelector('iframe');
    if (!iframe) return document.createElement('div');

    iframe.setAttribute('allow', 'autoplay; encrypted-media');
    iframe.setAttribute('allowfullscreen', '');

    return iframe;
  }
}
if (!customElements.get('vimeo-embedded-videos-container')) {
  customElements.define('vimeo-embedded-videos-container', VimeoEmbeddedContainer);
}

class VimeoEmbeddedModal extends HTMLElement {
  connectedCallback() {
    this.container = this.closest('vimeo-embedded-videos-container');
    this.thumbnail = this.querySelector('.js_thumb');
    this.videoTitle = this.querySelector('.js_title');
    this.iframe = null;

    this.url = this.getUrl();
    if (!this.url) {
      this.selfDestroy();
      if (this.container) this.container.incrementErrors();
      return;
    }

    this.bindedFetchVideoInfo = this.fetchVideoInfos.bind(this);
    if (document.readyState === 'complete') {
      this.fetchVideoInfos();
    } else {
      window.addEventListener('load',this.bindedFetchVideoInfo);
    }

    this.bindedClickHandler = this.clickHandler.bind(this);
    this.addEventListener('click',this.bindedClickHandler);
  }

  getUrl() {
    const raw = this.getAttribute('data-video-url');
    if (!raw) return null;
    try {
      return new URL(
        raw.startsWith('http://') || raw.startsWith('https://')
          ? raw
          : `https://${raw}`
      );
    } catch (error) {
      console.error('new URL() failed', error);
      return null;
    }
  }
  async fetchVideoInfos() {
    try{
      const response = await fetch(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(this.url.href)}&responsive=true`);
      if (!response.ok) throw new Error(`Could not fetch video ${this.url.href}: ${response.statusText}`);
      const data = await response.json();

      const thumb = {
        src:data?.thumbnail_url,
        width: data?.thumbnail_width,
        height: data?.thumbnail_height
      }
      const title = data?.title;
      this.iframe = data?.html;

      this.setThumbnail(thumb);
      this.setTitle(title);
      if (this.container) this.container.incrementSuccess();
    }
    catch(error){
      console.error('Fetching Vimeo Video: ',this.url.href,': ', error);
      this.selfDestroy();
      if (this.container) this.container.incrementErrors();
    }
  }
  setThumbnail(thumb){
    if (!this.thumbnail || !thumb?.src) {
      if (this.container) this.container.incrementIgnoreThumb();
      return;
    }
    this.thumbnail.src = thumb.src;
    if (this.container){
      this.container.addRatio(thumb?.height,thumb?.width);
    }
  }
  setTitle(title){
    if (this.videoTitle && title && title.trim() !== "") {
      this.videoTitle.textContent = title;
      this.videoTitle.classList.remove('hidden');
    }
  }
  clickHandler() {
    if (!this.iframe || !this.container) return;
    this.container.openModal(this.iframe);
  }
  selfDestroy(){
    this.closest('li')?.remove() || this.remove();
  }
}
if (!customElements.get('vimeo-embedded-modal')) {
  customElements.define('vimeo-embedded-modal', VimeoEmbeddedModal);
}